import React, { Component } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Sidebar from "../../common/Sidebar";
import { AssigmentDetailsIconLayout, DialogSaveButton, TableRadioButton } from "../../common/Global/globalStyles.style";
import SettingTopMenu from "./topmenu";
import Topbar from "../../common/Topbar";
import { FilterCheckBox } from "../../common/Global/globalStyles.style";
import { getThemeSettingsVariables, getLocalStorageVariables, isEmptyVariable, isEmptyArray, handleTokenExpiry, hasFeatureAccess} from "../../common/Global/commonFunctions";
import * as Constants from '../../common/Global/constants';
import AlertDialog from "../../common/AlertDialog";
import * as TemplateConstants from '../../common/Global/templateConstants';
import { Modal } from "react-bootstrap";
import RegularDropDown from "../../common/DropdownMenus/RegularDropdown";
import { CheckBoxSelection, Inject, MultiSelectComponent } from '@syncfusion/ej2-react-dropdowns';
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-buttons/styles/material.css";
import "@syncfusion/ej2-inputs/styles/material.css";
import "@syncfusion/ej2-react-dropdowns/styles/material.css";

let themeSettings = getThemeSettingsVariables();
let userDetails = "";
const assignmentTypeDropdownDefaultValue = "Select Assignment Type";
const departmentDropdownDefaultValue = "Select Department";
const templateDropdownDefaultValue = "Select Template";
const RISK_MATRIX_CHECKBOX_COLUMNS = ["executionTask", "observationRadio", "processFunctionLevel"];
const RESPONSE_RADIO_COLUMNS = ["responseTask", "responseObservation", "responseBoth"];

const STANDARD_REPORT_ID = 0;
const STANDARD_REPORT_ITEM = { displayReportName: "Standard Report", clientDownloadReportMapId: STANDARD_REPORT_ID };

let templateDefaultSettings = {
    // "observationCheckbox": {
    //     "settingDisplayColumn": "Observation",
    //     "showCheckbox": "Y",
    //     "showRadioButton": "N",
    //     "settingColumn": "observationCheckbox",
    //     "settingColumnEnabled": "N",
    //     "settingValue": "",
    //     "showTextbox": "Y",
    //     "textboxType": "Textbox"
    // },
    // "general": {
    //     "settingDisplayColumn": "General",
    //     "showCheckbox": "Y",
    //     "showRadioButton": "N",
    //     "settingColumn": "general",
    //     "settingColumnEnabled": "N",
    //     "settingValue": "",
    //     "showTextbox": "Y",
    //     "textboxType": "Textbox"
    // },
    // "response": {
    //     "settingDisplayColumn": "Response",
    //     "showCheckbox": "Y",
    //     "showRadioButton": "N",
    //     "settingColumn": "response",
    //     "settingColumnEnabled": "N",
    //     "settingValue": "",
    //     "showTextbox": "Y",
    //     "textboxType": "Textbox"
    // },
    // "followup": {
    //     "settingDisplayColumn": "Follow-up",
    //     "showCheckbox": "Y",
    //     "showRadioButton": "N",
    //     "settingColumn": "followup",
    //     "settingColumnEnabled": "N",
    //     "settingValue": "",
    //     "showTextbox": "Y",
    //     "textboxType": "Textbox"
    // },
    "docList": {
        "settingDisplayColumn": "Doc List",
        "showCheckbox": "Y",
        "showRadioButton": "N",
        "settingColumn": "docList",
        "settingColumnEnabled": "N",
        "settingValue": "",
        "showTextbox": "Y",
        "textboxType": "Textbox"
    },
    "auditee": {
        "settingDisplayColumn": "Auditee",
        "showCheckbox": "Y",
        "showRadioButton": "N",
        "settingColumn": "auditee",
        "settingColumnEnabled": "N",
        "settingValue": "",
        "showTextbox": "Y",
        "textboxType": "Textbox"
    },
    "timeline": {
        "settingDisplayColumn": "Timeline",
        "showCheckbox": "Y",
        "showRadioButton": "N",
        "settingColumn": "timeline",
        "settingColumnEnabled": "N",
        "settingValue": "",
        "showTextbox": "Y",
        "textboxType": "Textbox"
    },
    "general": {
        "settingDisplayColumn": "General",
        "showCheckbox": "Y",
        "showRadioButton": "N",
        "settingColumn": "general",
        "settingColumnEnabled": "N",
        "settingValue": "",
        "showTextbox": "Y",
        "textboxType": "Textbox"
    },
    "executionTask":{
        "settingDisplayColumn": "Execution Task",
        "showCheckbox": "Y",
        "showRadioButton": "N",
        "settingColumn": "executionTask",
        "settingColumnEnabled": "N",
        "settingValue": "",
        "showTextbox": "Y",
        "textboxType": "Textbox"
    },
    "observationRadio":{
        "settingDisplayColumn": "Observation",
        "showCheckbox": "Y",
        "showRadioButton": "N",
        "settingColumn": "observationRadio",
        "settingColumnEnabled": "N",
        "settingValue": "",
        "showTextbox": "Y",
        "textboxType": "Textbox"
    },
    "processFunctionLevel": {
        "settingDisplayColumn": "Process / Function Level",
        "showCheckbox": "Y",
        "showRadioButton": "N",
        "settingColumn": "processFunctionLevel",
        "settingColumnEnabled": "N",
        "settingValue": "",
        "showTextbox": "N",
        "textboxType": "Textbox"
    },
    "allowMatrixUsageChangeDuringScheduling": {
        "settingDisplayColumn": "Allow change in usage of matrix during scheduling",
        "showCheckbox": "Y",
        "showRadioButton": "N",
        "settingColumn": "allowMatrixUsageChangeDuringScheduling",
        "settingColumnEnabled": "N",
        "settingValue": "",
        "showTextbox": "N",
        "textboxType": "Textbox"
    },
    "responseTask": {
        "settingDisplayColumn": "Task",
        "showCheckbox": "N",
        "showRadioButton": "Y",
        "settingColumn": "responseTask",
        "settingColumnEnabled": "N",
        "settingValue": "",
        "showTextbox": "Y",
        "textboxType": "Textbox"
    },
    "responseObservation": {
        "settingDisplayColumn": "Observation",
        "showCheckbox": "N",
        "showRadioButton": "Y",
        "settingColumn": "responseObservation",
        "settingColumnEnabled": "N",
        "settingValue": "",
        "showTextbox": "Y",
        "textboxType": "Textbox"
    },
    "responseBoth": {
        "settingDisplayColumn": "Both",
        "showCheckbox": "N",
        "showRadioButton": "Y",
        "settingColumn": "responseBoth",
        "settingColumnEnabled": "N",
        "settingValue": "",
        "showTextbox": "Y",
        "textboxType": "Textbox"
    },
    "allowEditClientComment": {
        "settingDisplayColumn": "Allow Editing of client comment by User",
        "showCheckbox": "Y",
        "showRadioButton": "N",
        "settingColumn": "allowEditClientComment",
        "settingColumnEnabled": "N",
        "settingValue": "",
        "showTextbox": "Y",
        "textboxType": "Textbox"
    },
    "allowReassignTaskByClient": {
        "settingDisplayColumn": "Allow Re-Assigning of the task by client employee",
        "showCheckbox": "Y",
        "showRadioButton": "N",
        "settingColumn": "allowReassignTaskByClient",
        "settingColumnEnabled": "N",
        "settingValue": "",
        "showTextbox": "Y",
        "textboxType": "Textbox"
    },
    "allowClientToRespond": {
        "settingDisplayColumn": "Allow client to respond",
        "showCheckbox": "Y",
        "showRadioButton": "N",
        "settingColumn": "allowClientToRespond",
        "settingColumnEnabled": "N",
        "settingValue": "",
        "showTextbox": "N",
        "textboxType": "Textbox"
    },
    "skipDraftStage": {
        "settingDisplayColumn": "Skip Draft Stage",
        "showCheckbox": "Y",
        "showRadioButton": "N",
        "settingColumn": "skipDraftStage",
        "settingColumnEnabled": "N",
        "settingValue": "",
        "showTextbox": "N",
        "textboxType": "Textbox"
    },
    "clientResponseAfterCompletion": {
        "settingDisplayColumn": "Client Response after completion",
        "showCheckbox": "Y",
        "showRadioButton": "N",
        "settingColumn": "clientResponseAfterCompletion",
        "settingColumnEnabled": "N",
        "settingValue": "",
        "showTextbox": "N",
        "textboxType": "Textbox"
    },
    "assignRiskAssignmentLevel": {
        "settingDisplayColumn": "Do you want to assign risk level at assignment level?",
        "showCheckbox": "Y",
        "showRadioButton": "N",
        "settingColumn": "assignRiskAssignmentLevel",
        "settingColumnEnabled": "N",
        "settingValue": "",
        "showTextbox": "N",
        "textboxType": "Textbox"
    },
    "defaultMailReport": {
        "settingDisplayColumn": "Default Mail Report",
        "showCheckbox": "N",
        "showRadioButton": "N",
        "settingColumn": "defaultMailReport",
        "settingColumnEnabled": "N",
        // Dash-separated clientDownloadReportMapId values selected in the multi-select, e.g. "1-2-3".
        "settingValue": "",
        "showTextbox": "N",
        "textboxType": "Textbox"
    },
}
export default class TemplateSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            componentDidMountFlag: false,
            showLoader: false,
            showBtnLoader: false,
            formErrors: {},
            menus: "",
            showAlertDialogInfo:false,
            showFilter:false,
            alertDialogMessageInfo:"",
            selectedDepartmentId:"",
            selectedassignmentTypeId:"",
            selectedTemplateId:"",
            selectedDepartmentName:departmentDropdownDefaultValue,
            selectedAssignmentType:assignmentTypeDropdownDefaultValue,
            selectedTemplate:templateDropdownDefaultValue,
            templateSettings:templateDefaultSettings,
            downloadReportList:[],
            clientId:"",
            submitClickedAtleastOnce:false,
            showDialog:false
        }
        userDetails = getLocalStorageVariables();
        themeSettings = getThemeSettingsVariables();
    }

    componentDidMount() {
        this.getUserMenu();
    }

    // This function to handle checkbox click events
    handleCheckBoxClick = (e) => {
        let isChecked = e.target.checked;
        const { name } = e.target;

        let templateSettingsTemp = this.state.templateSettings;

        // "Where would you like to use risk and likelihood matrix?" - Execution Task / Observation /
        // Process Function - only 2 of the 3 may be selected at once. Block checking a 3rd.
        if(isChecked && RISK_MATRIX_CHECKBOX_COLUMNS.includes(name)){
            const otherCheckedCount = RISK_MATRIX_CHECKBOX_COLUMNS.filter(col =>
                col !== name && templateSettingsTemp[col]?.settingColumnEnabled === "Y"
            ).length;
            if(otherCheckedCount >= 2){
                return;
            }
        }

        templateSettingsTemp[name]["settingColumnEnabled"] = isChecked?"Y":"N";

        this.setState({
            templateSettings: templateSettingsTemp,
        });
    }

    handleRadioButtonSelection = (selectedColumn) => {
        let templateSettingsTemp = { ...this.state.templateSettings };
        Object.values(templateSettingsTemp).forEach(item => {
            if (item.showRadioButton === "Y" && RESPONSE_RADIO_COLUMNS.includes(item.settingColumn)) {
                item.settingColumnEnabled = item.settingColumn === selectedColumn ? "Y" : "N";
            }
        });
        this.setState({
            templateSettings: templateSettingsTemp,
        });
    }

    // Handle Department Dropdown selection based on that API call for getting Assignment Type
    deptDropdownClick = (item) => {
        let FormErrorsTemp = this.state.formErrors;

        if (this.state.submitClickedAtleastOnce) {
            FormErrorsTemp['department'] = "";
        }

        this.setState({
            selectedDepartmentName: item.name,
            selectedDepartmentId: item.departmentId,
            formErrors: FormErrorsTemp,
            selectedAssignmentType:assignmentTypeDropdownDefaultValue,
            selectedassignmentTypeId:""
        }, () => {
            this.getUserAllAssignmentTypes();
        })
    }

    // Handle Assignment Type Dropdown
    assignmentTypeDropdownClick = (item) => {
        let FormErrorsTemp = this.state.formErrors;

        if (this.state.submitClickedAtleastOnce) {
            FormErrorsTemp['assignmentType'] = "";
        }

        this.setState({
            selectedAssignmentType: item.name,
            selectedassignmentTypeId: item.assignmentTypeId,
            formErrors: FormErrorsTemp,
            selectedTemplate: templateDropdownDefaultValue,
            selectedTemplateId: ""
        }, () => {
            this.getTemplate();
        })
    }

    templateDropdownClick = (item) => {
        let FormErrorsTemp = this.state.formErrors;

        if (this.state.submitClickedAtleastOnce) {
            FormErrorsTemp['template'] = "";
        }

        this.setState({
            formErrors: FormErrorsTemp,
            selectedTemplate: item.templateName,
            selectedTemplateId: item.rootTemplateId,
        })
    }

    // This function to handle input field change events
    handleTaskFieldsChange = (e) => {
        let FormErrorsTemp = this.state.formErrors;
        const { name, value } = e.target;
        let templateSettingsTemp = this.state.templateSettings;
        templateSettingsTemp[name]["settingValue"] = value;

        if (this.state.submitClickedAtleastOnce) {
            FormErrorsTemp[name]["settingColumn"] = "";
        }

        this.setState({
            templateSettings: templateSettingsTemp,
            formErrors: FormErrorsTemp
        });
    };

    // Edit Department and Assignment Type selection 
    updateSetting = () => {
        // Set initial Value inside modal if Department not one
        if(this.state.departmentsArr.length !== 1){
            this.setState({
                selectedDepartmentId:"",
                selectedDepartmentName:departmentDropdownDefaultValue,
                assignmentTypeArr:[]
            })
        }
        if(this.state.assignmentTypeArr.length !== 1){
            this.setState({
                selectedassignmentTypeId:"",
                selectedAssignmentType:assignmentTypeDropdownDefaultValue,
                templateArr:[]
            })
        }
        this.setState({
            showDialog:true, // Show Department, Assignment and Template dropdown in modal
            selectedTemplateId:"",
            selectedTemplate:templateDropdownDefaultValue,
        })
    }

     // Handle Info dialog close event
    handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        })
    }

    // Handle modal close event
    handleDialogClose = () => {
        this.setState({
            showDialog:false
        })
    }

    // Save selection of Department and Assignment Type
    handleSave = () => {
        let isError = false;
        let formErrTemp = {};
        this.setState({
            submitClickedAtleastOnce:true
        });
        // Check if Department, Assignment Type and Template is selected or not
        if(isEmptyVariable(this.state.selectedDepartmentId)){
            isError = true;
            formErrTemp["department"] = "Please select the department";
        }
    
        if(!isEmptyArray(this.state.assignmentTypeArr) && isEmptyVariable(this.state.selectedassignmentTypeId)){
            isError = true;
            formErrTemp["assignmentType"] = "Please select the assignment type";
        }

        if(!isEmptyArray(this.state.templateArr) && isEmptyVariable(this.state.selectedTemplateId)){
            isError = true;
            formErrTemp["template"] = "Please select the template";
        }
        if (isError) {
            this.setState({
                formErrors: formErrTemp
            });
        } else {
            // Assignment Type is not then clear previous selction value and set message
            if(isEmptyArray(this.state.assignmentTypeArr)){
                this.setState({
                    componentDidMountFlag:false,
                    assignmentType:"",
                    selectedAssignmentType:assignmentTypeDropdownDefaultValue,
                    selectedassignmentTypeId:"",
                    showMessage:true,
                    responseMessage:"No assignment type created in selected department.",
                })
            }
            // Template is not then clear previous selction value and set message
            if(isEmptyArray(this.state.templateArr)){
                this.setState({
                    componentDidMountFlag:false,
                    template:"",
                    selectedTemplate:templateDropdownDefaultValue,
                    selectedTemplateId:"",
                    showMessage:true,
                    responseMessage:"No template created in selected department and assignment type.",
                })
            }
    
            // Set the Department value
            this.setState({
                showDialog:false,
                showFilter:true, // Display selected Department, Assignment Type and Template
                departmentName:this.state.selectedDepartmentName, // Used for the display Department name
            })
    
            // Set selected assignment type value and call API for getting setting
            if(!isEmptyArray(this.state.assignmentTypeArr)){
                this.setState({
                    assignmentType:this.state.selectedAssignmentType, // Used for the display assignment Type name
                    showMessage:false,
                    responseMessage:""
                })
            }

            // Set selected template value
            if(!isEmptyArray(this.state.templateArr)){
                this.setState({
                    templateName:this.state.selectedTemplate, // Used for the display template name
                    showMessage:false,
                    responseMessage:""
                },()=>{
                    this.getTemplateSetting();
                })
            }
        }
    }
    /*******************API CALLS*******************/
    getUserMenu = () => {
        fetch(Constants.GetUserMenu, {
            method: "POST",
            mode: 'cors',
            body: new URLSearchParams({
                email: userDetails.email,
                accessToken: userDetails.accessToken,
            }),
        })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            let tempMenusData = ""
            let departmentsArr = [];
            let clientId = "";
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                tempMenusData = data.data.menus;
                departmentsArr = data.data.departments;
                clientId = data.data.user.clientId;
                
                // If department Arr length one then automatic set department name and Id
                if(departmentsArr.length === 1){
                    this.setState({
                        // Used for the Department dropdown selection
                        selectedDepartmentName: departmentsArr[0].name,
                        selectedDepartmentId: departmentsArr[0].departmentId   
                    })
                    if(!this.state.showDialog){
                        this.setState({
                            // Used for the display department name
                            departmentName:departmentsArr[0].name 
                        },() => {
                            // If department Arr length one then pass true
                            this.getUserAllAssignmentTypes(true);
                        })
                    }
                }else{
                    this.setState({
                        showDialog:true
                    })
                }
                this.setState({
                    showLoader: false,
                    menus: tempMenusData,
                    departmentsArr: departmentsArr,
                    clientId: clientId
                })
            }else{
            }
        })
    }

    getUserAllAssignmentTypes = (reload) => {
        fetch(Constants.GetUserAllAssignmentTypes, {
            method: "POST",
            mode: 'cors',
            body: new URLSearchParams({
                email: userDetails.email,
                accessToken: userDetails.accessToken,
                departmentId:this.state.selectedDepartmentId
            })
        })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                let assignmentTypeArr = data.data;

                // Check reload is true and assignmentTypeArr is empty then clear value and set message
                if(reload == true && isEmptyArray(assignmentTypeArr)){
                    this.setState({
                        componentDidMountFlag:false,
                        selectedAssignmentType:assignmentTypeDropdownDefaultValue,
                        selectedassignmentTypeId:"",
                        assignmentType:"",
                        showMessage:true,
                        responseMessage:"No assignment type created in selected department."
                    })
                }

                // assignmentTypeArr is one then set AssignmentType and Id
                if(assignmentTypeArr.length === 1){
                    this.setState({
                        // Used for the Assignment Type dropdown selection
                        selectedAssignmentType: assignmentTypeArr[0].name,
                        selectedassignmentTypeId: assignmentTypeArr[0].assignmentTypeId
                    })
                    if(!this.state.showDialog){
                        // Used for the display assignment Type name
                        this.setState({
                            assignmentType:assignmentTypeArr[0].name
                        }, () => {
                            // If assignmentTypeArr length one then pass true
                            this.getTemplate(true);
                        })
                    }
                }else if(!isEmptyArray(assignmentTypeArr)){
                    this.setState({
                        showDialog:true
                    })
                }
                
                this.setState({
                    assignmentTypeArr: assignmentTypeArr
                })
            }else{
            }
        })
    }

    getTemplate = (reload) => {
        let postParam = {
            email: userDetails.email,
            accessToken: userDetails.accessToken,
            templateType:TemplateConstants.TEMPLATE_TYPE_EX_TASK,
            pageNo: 1,
            resultsize: 100,
            status_new: "Active",
            sort:"",
            sortDir: "",
            assignmentTypeId:this.state.selectedassignmentTypeId
        }
        if(!isEmptyVariable(this.state.clientId)){
            postParam.clientId = this.state.clientId
        }
        fetch(Constants.GetTemplates, {
            method: "POST",
            mode: "cors",
            body: new URLSearchParams(postParam),
        })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            if(handleTokenExpiry(data.responseCode)) return;
            else if (data.responseCode === Constants.CODE_SUCCESS) {
                let templateArr = data.data.result;

                // Template is not then clear previous selction value and set message
                if(reload == true && isEmptyArray(templateArr)){
                    this.setState({
                        componentDidMountFlag:false,
                        selectedTemplate:templateDropdownDefaultValue,
                        selectedTemplateId:"",
                        templateName:"",
                        showMessage:true,
                        responseMessage:"No template created in selected department and assignment type.",
                    })
                }

                // assignmentTypeArr is one then set AssignmentType and Id
                if(templateArr.length === 1){
                    this.setState({
                        // Used for the Assignment Type dropdown selection
                        selectedTemplate: templateArr[0].templateName,
                        selectedTemplateId: templateArr[0].rootTemplateId
                    })
                    if(!this.state.showDialog){
                        // Used for the display assignment Type name
                        this.setState({
                            templateName:templateArr[0].templateName
                        },() => {
                            this.getTemplateSetting();
                        })
                    }
                }else if(templateArr.length > 1){
                    this.setState({
                        showDialog:true
                    })
                }
                this.setState({
                    templateArr: templateArr
                });
            } else {
            }
        });
    }

    getTemplateSetting = () => {
        this.setState({
            showLoader: true
        });
        fetch(Constants.GetTemplateSetting, {
            method: "POST",
            mode: 'cors',
            body: new URLSearchParams({
                email: userDetails.email,
                accessToken: userDetails.accessToken,
                templateId:this.state.selectedTemplateId
            })
        })
        .then((templateSettings) => {
            return templateSettings.json();
        })
        .then((templateSettings) => {
            let tempTemplateSettings = {};

            if(handleTokenExpiry(templateSettings.responseCode)) return;
            else if (templateSettings.responseCode === Constants.CODE_SUCCESS) {
                tempTemplateSettings = templateSettings.data[0]?.settingDetails ?? {};

                if (isEmptyArray(Object.keys(tempTemplateSettings))) {
                    tempTemplateSettings = templateDefaultSettings;
                }else {
                    Object.keys(templateDefaultSettings).forEach((key) => {
                        if (!tempTemplateSettings.hasOwnProperty(key)) {
                            tempTemplateSettings[key] = templateDefaultSettings[key];
                        }
                    });
                    // executionTask/observationRadio used to be radio-group columns - templates saved
                    // before that changed to checkboxes still carry the old showCheckbox/showRadioButton
                    // flags, so force them to the current checkbox representation on every load.
                    ["executionTask", "observationRadio"].forEach((key) => {
                        if (tempTemplateSettings[key]) {
                            tempTemplateSettings[key].showCheckbox = "Y";
                            tempTemplateSettings[key].showRadioButton = "N";
                        }
                    });
                }
                if(!hasFeatureAccess(Constants.FEATURE_EXECUTE_SAMPLE_CHECKED)){
                    delete tempTemplateSettings.docList;
                }
                if(!hasFeatureAccess(Constants.FEATURE_AUDITEE)){
                    delete tempTemplateSettings.auditee;
                }
                if(!hasFeatureAccess(Constants.FEATURE_TIMELINE)){
                    delete tempTemplateSettings.timeline;
                }
                if(!hasFeatureAccess(Constants.FEATURE_MATRIX_RISK)){
                    delete tempTemplateSettings.executionTask;
                    delete tempTemplateSettings.observationRadio;
                    delete tempTemplateSettings.processFunctionLevel;
                    delete tempTemplateSettings.allowMatrixUsageChangeDuringScheduling;
                }
                if(!hasFeatureAccess(Constants.FEATURE_OBSERVATION)){
                    delete tempTemplateSettings.observationRadio;
                    // delete tempTemplateSettings.processFunctionLevel;
                }
                if(!hasFeatureAccess(Constants.FEATURE_ASSIGN_TO_PROCESS_FUNCTION)){
                    delete tempTemplateSettings.processFunctionLevel;
                }
                if(!hasFeatureAccess(Constants.FEATURE_GENERAL_TEMPLATE)){
                    delete tempTemplateSettings.general;
                }
                if(!hasFeatureAccess(Constants.FEATURE_EMAIL_NOTIFICATION)){
                    delete tempTemplateSettings.defaultMailReport;
                }
                if(!hasFeatureAccess(Constants.FEATURE_CLIENT_LOGIN)){
                    delete tempTemplateSettings.allowEditClientComment;
                    delete tempTemplateSettings.allowReassignTaskByClient;
                    delete tempTemplateSettings.allowClientToRespond;
                } else {
                    if(!hasFeatureAccess(Constants.FEATURE_EDIT_CLIENT_COMMENT)){
                        delete tempTemplateSettings.allowEditClientComment;
                    }
                    if(!hasFeatureAccess(Constants.FEATURE_TASK_REASSIGN_FOR_CLIENT_EMPLOYEE)){
                        delete tempTemplateSettings.allowReassignTaskByClient;
                    }
                }
            }else {
                tempTemplateSettings = ""
            }
            this.setState({
                componentDidMountFlag: true,
                showLoader: false,
                templateSettings: tempTemplateSettings
            })
            if(hasFeatureAccess(Constants.FEATURE_EMAIL_NOTIFICATION)){
                this.getDownloadReportList();
            }
        })
    }

    getDownloadReportList = () => {
        fetch(Constants.GetDownloadReportList, {
            method: "POST",
            mode: "cors",
            body: new URLSearchParams({
                email: userDetails.email,
                accessToken: userDetails.accessToken,
                departmentId: this.state.selectedDepartmentId
            }),
        })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            if(handleTokenExpiry(data.responseCode)) return;
            else if (data.responseCode === Constants.CODE_SUCCESS) {
                this.setState({
                    downloadReportList: data.data ?? [],
                });
            }
        })
    }

    // Reads the currently-selected report ids out of the defaultMailReport setting's dash-separated string.
    getSelectedDefaultMailReportIds = () => {
        let settingValue = this.state.templateSettings?.defaultMailReport?.settingValue;
        if(isEmptyVariable(settingValue)) return [];
        return settingValue.split("-").filter(id => id !== "");
    }

    // Persists the multi-select's current selection as a dash-separated string, e.g. "1-2-3".
    setSelectedDefaultMailReportIds = (selectedIds) => {
        let templateSettingsTemp = { ...this.state.templateSettings };
        templateSettingsTemp.defaultMailReport = {
            ...templateSettingsTemp.defaultMailReport,
            settingValue: selectedIds.join("-"),
            settingColumnEnabled: selectedIds.length > 0 ? "Y" : "N",
        };
        this.setState({
            templateSettings: templateSettingsTemp,
        });
    }

    handleDefaultMailReportSelect = (args) => {
        let selectedIds = this.getSelectedDefaultMailReportIds();
        let newId = args.itemData.clientDownloadReportMapId+"";
        if(!selectedIds.includes(newId)){
            this.setSelectedDefaultMailReportIds([...selectedIds, newId]);
        }
    }

    handleDefaultMailReportRemove = (args) => {
        let selectedIds = this.getSelectedDefaultMailReportIds();
        let removedId = args.itemData.clientDownloadReportMapId+"";
        this.setSelectedDefaultMailReportIds(selectedIds.filter(id => id !== removedId));
    }

    // This function to handle update the settings
    handleSaveFields = () => {
        this.setState({
            showBtnLoader: true,
            submitClickedAtleastOnce:true
        });
        let isError = false;
        let formErrTemp = {};

        if(isEmptyVariable(this.state.selectedDepartmentId)){
            isError = true;
            formErrTemp["department"] = "Please select the department";
        }
        
        if(isEmptyVariable(this.state.selectedassignmentTypeId)){
            isError = true;
            formErrTemp["assignmentType"] = "Please select the assignment type";
        }

        if(isEmptyVariable(this.state.selectedTemplateId)){
            isError = true;
            formErrTemp["template"] = "Please select the template";
        }
        
        if (isError) {
            this.setState({
                formErrors: formErrTemp,
                showBtnLoader:false
            });
        } else {
            let settingDetailsTemp = {};
            Object.keys(this.state.templateSettings).forEach((key) => {
                settingDetailsTemp[key] = {
                    ...this.state.templateSettings[key],
                    departmentId: this.state.selectedDepartmentId,
                    assignmentTypeId: this.state.selectedassignmentTypeId
                };
            });

            const updatedValues = [
                {
                    rootTemplateId: this.state.selectedTemplateId,
                    settingDetails: settingDetailsTemp
                }
            ];
            fetch(Constants.SaveTemplateSetting+this.state.clientId, {
                method: "POST",
                mode: "cors",
                body: new URLSearchParams({
                    email: userDetails.email,
                    accessToken: userDetails.accessToken,
                    updatedValues: JSON.stringify(updatedValues),
                }),
            })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                if(handleTokenExpiry(data.responseCode)) return;
                else if (data.responseCode === Constants.CODE_SUCCESS) {
                    this.setState({
                        showBtnLoader: false,
                        showAlertDialogInfo: true,
                        alertDialogMessageInfo: "Settings updated successfully",
                    }, () => {
                        this.getTemplateSetting();
                    });
                } else {
                    this.setState({
                        showBtnLoader: false,
                        showAlertDialogInfo:true,
                        alertDialogMessageInfo:data.responseMessage
                    })
                }
            });
        }
    };
    /*******************API CALLS END HERE*******************/
    
    render() {
        return (
            <Router>
                <main className="main-dashboard">
                    <section className="dashboard-bg">
                        <Sidebar />

                        <div className="dashboard-right-bg position-relative">
                            <div className="dashboard-wrapper">
                                <Topbar />
                                {
                                    // this.state.componentDidMountFlag &&
                                    <SettingTopMenu 
                                        themeSettings={themeSettings}
                                        menus={this.state.menus}
                                    />
                                }

                                {this.state.showLoader && (
                                    <div class="loader"></div>
                                )}

                                {
                                    // this.state.componentDidMountFlag &&
                                    <div className="body-wrapper">
                                        <div className="row custom-row">
                                            <div className="col-md-12 custom-col">
                                                <div className="card-col">
                                                    {this.state.showFilter &&
                                                        <div className="row custom-row">
                                                            <div className="col-md-12 custom-col d-flex align-items-center">
                                                                {!isEmptyVariable(this.state.departmentName) &&
                                                                    <p className="mr-5 mt-2">Department: {this.state.departmentName}</p>
                                                                }
                                                                {!isEmptyVariable(this.state.assignmentType) &&
                                                                    <p className="mr-5 mt-2">Assignment Type: {this.state.assignmentType}</p>
                                                                }
                                                                {!isEmptyVariable(this.state.templateName) &&
                                                                    <p className="mr-3 mt-2">Template: {this.state.templateName}</p>
                                                                }
                                                                {((!isEmptyArray(this.state.departmentsArr) && this.state.departmentsArr.length >= 1) || 
                                                                (!isEmptyArray(this.state.assignmentTypeArr) && this.state.assignmentTypeArr.length > 1) ||
                                                                (!isEmptyArray(this.state.templateArr) && this.state.templateArr.length > 1)) &&
                                                                    <AssigmentDetailsIconLayout themeSettings={themeSettings}>
                                                                        <span className="material-icons" style={{fontSize: 23}} 
                                                                            onClick={() => this.updateSetting()}>edit</span>
                                                                    </AssigmentDetailsIconLayout>
                                                                }
                                                            </div>
                                                        </div>
                                                    }
                                                    {/* Render checkboxes as before */}
                                                    {this.state.componentDidMountFlag && 
                                                    !isEmptyArray(Object.keys(this.state.templateSettings)) && 
                                                    <>
                                                        {Object.values(this.state.templateSettings)
                                                        .filter(
                                                            item =>
                                                                item.showCheckbox === "Y" &&
                                                                item.settingColumn !== "skipDraftStage" &&
                                                                item.settingColumn !== "clientResponseAfterCompletion" &&
                                                                item.settingColumn !== "assignRiskAssignmentLevel" &&
                                                                item.settingColumn !== "allowEditClientComment" &&
                                                                item.settingColumn !== "allowReassignTaskByClient" &&
                                                                item.settingColumn !== "allowClientToRespond" &&
                                                                !RISK_MATRIX_CHECKBOX_COLUMNS.includes(item.settingColumn) &&
                                                                item.settingColumn !== "allowMatrixUsageChangeDuringScheduling"
                                                        )
                                                        .map((item, index, arr) => {
                                                            // Find if this is the first of docList/auditee/timeline
                                                            const isFirstSpecial =
                                                                (item.settingColumn === "docList" ||
                                                                    item.settingColumn === "auditee" ||
                                                                    item.settingColumn === "timeline" ||
                                                                    item.settingColumn === "general") &&
                                                                // Only show heading if this is the first of the three
                                                                !arr
                                                                    .slice(0, index)
                                                                    .some(
                                                                        prev =>
                                                                            prev.settingColumn === "docList" ||
                                                                            prev.settingColumn === "auditee" ||
                                                                            prev.settingColumn === "timeline" ||
                                                                            prev.settingColumn === "general"
                                                                    );
                                                            return(
                                                            <div key={item.settingColumn}>
                                                                {/* {item.settingColumn === "observationCheckbox" && 
                                                                    <p style={{fontWeight:400, marginBottom: 15, marginTop: 15}}>
                                                                        Template you want to create for the execution templates
                                                                    </p>
                                                                } */}
                                                                {isFirstSpecial && (
                                                                    <p style={{
                                                                        fontWeight: 400,
                                                                        marginBottom: 15,
                                                                        paddingTop: 15,
                                                                        borderTop: "1px solid #ccc"
                                                                    }}>
                                                                        Would you like to collect information under following headings?
                                                                    </p>
                                                                )}
                                                                {/* {Object.values(this.state.templateSettings).some(
                                                                    item => item.settingColumn === "docList" ||
                                                                            item.settingColumn === "auditee" ||
                                                                            item.settingColumn === "timeline"
                                                                ) && (
                                                                    <p style={{fontWeight:400, marginBottom: 15,  paddingTop: 15, borderTop: "1px solid #ccc"}}>
                                                                        Would you like to collect information under following headings?
                                                                    </p>
                                                                )} */}
                                                                <div className="row custom-row">
                                                                    <div className="col-md-1 custom-col" style={{maxWidth:'3.33%'}}>
                                                                        <div className="flex-center-layout">
                                                                            <FilterCheckBox
                                                                                themeSettings={themeSettings}
                                                                                style={{ marginLeft: 0, marginBottom: 0, marginTop: 0 }}
                                                                            >
                                                                                <input
                                                                                    type="checkbox"
                                                                                    name={item["settingColumn"]}
                                                                                    id={item["settingColumn"]}
                                                                                    onChange={this.handleCheckBoxClick}
                                                                                    checked={item.settingColumnEnabled === "Y" ? true : false}
                                                                                />
                                                                                <label htmlFor={item["settingColumn"]} style={{fontWeight:600, color:"#000"}}></label>
                                                                            </FilterCheckBox>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-8 custom-col flex-center-layout">
                                                                        <div className="add-new-form-group">
                                                                            <p>{item["settingDisplayColumn"]}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            )
                                                        })}
                                                        {/* {hasFeatureAccess(Constants.FEATURE_CLIENT_LOGIN) &&
                                                        Object.values(this.state.templateSettings)
                                                            .filter(
                                                                item =>
                                                                    item.showCheckbox === "Y" &&
                                                                    (item.settingColumn === "allowEditClientComment" || item.settingColumn === "allowReassignTaskByClient")
                                                            ).map(item => (
                                                            <div key={item.settingColumn}>
                                                                {item.settingColumn === "allowEditClientComment" &&
                                                                    <p style={{fontWeight:400, paddingTop: 15, marginBottom: 15, borderTop: "1px solid #ccc"}}>
                                                                        Client Response
                                                                    </p>
                                                                }
                                                                <div className="row custom-row">
                                                                    <div className="col-md-1 custom-col" style={{maxWidth:'3.33%'}}>
                                                                        <div className="flex-center-layout">
                                                                            <FilterCheckBox
                                                                                themeSettings={themeSettings}
                                                                                style={{ marginLeft: 0, marginBottom: 0, marginTop: 0 }}
                                                                            >
                                                                                <input
                                                                                    type="checkbox"
                                                                                    name={item["settingColumn"]}
                                                                                    id={item["settingColumn"]}
                                                                                    onChange={this.handleCheckBoxClick}
                                                                                    checked={item.settingColumnEnabled === "Y"}
                                                                                />
                                                                                <label htmlFor={item["settingColumn"]}></label>
                                                                            </FilterCheckBox>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-8 custom-col flex-center-layout">
                                                                        <div className="add-new-form-group">
                                                                            <p>{item["settingDisplayColumn"]}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))} */}
                                                        {/* Render checkboxes horizontally in one row */}
                                                        {hasFeatureAccess(Constants.FEATURE_MATRIX_RISK) &&
                                                            <p style={{fontWeight:400, paddingTop: 15, marginBottom: 15, borderTop: "1px solid #ccc"}}>
                                                                Where would you like to use risk and likelihood matrix?
                                                            </p>
                                                        }
                                                        <div className="row custom-row">
                                                            <div className="col-md-8 custom-col">
                                                                <div style={{display: "flex", flexDirection: "row", gap: "20px", alignItems: "center", marginBottom:15}}>
                                                                    {Object.values(this.state.templateSettings).filter(item => item.showCheckbox === "Y" && RISK_MATRIX_CHECKBOX_COLUMNS.includes(item.settingColumn)).map((item, index) => (
                                                                        <FilterCheckBox
                                                                            key={item.settingColumn}
                                                                            style={{marginLeft:0, display:"flex", flexDirection: "column", alignItems: "center", marginBottom: 10}}
                                                                            themeSettings={themeSettings}
                                                                        >
                                                                            <input
                                                                                type="checkbox"
                                                                                name={item["settingColumn"]}
                                                                                id={item["settingColumn"]}
                                                                                onChange={this.handleCheckBoxClick}
                                                                                checked={item.settingColumnEnabled === "Y"}
                                                                            />
                                                                            <label htmlFor={item["settingColumn"]} style={{marginLeft:0, fontWeight:600, color:"#000"}}>{item["settingDisplayColumn"]}</label>
                                                                        </FilterCheckBox>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {hasFeatureAccess(Constants.FEATURE_MATRIX_RISK) &&
                                                        this.state.templateSettings?.allowMatrixUsageChangeDuringScheduling &&
                                                        <div className="row custom-row">
                                                            <div className="col-md-1 custom-col" style={{maxWidth:'3.33%'}}>
                                                                <div className="flex-center-layout">
                                                                    <FilterCheckBox
                                                                        themeSettings={themeSettings}
                                                                        style={{ marginLeft: 0, marginBottom: 0, marginTop: 0 }}
                                                                    >
                                                                        <input
                                                                            type="checkbox"
                                                                            name="allowMatrixUsageChangeDuringScheduling"
                                                                            id="allowMatrixUsageChangeDuringScheduling"
                                                                            onChange={this.handleCheckBoxClick}
                                                                            checked={this.state.templateSettings.allowMatrixUsageChangeDuringScheduling.settingColumnEnabled === "Y"}
                                                                        />
                                                                        <label htmlFor="allowMatrixUsageChangeDuringScheduling"></label>
                                                                    </FilterCheckBox>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-8 custom-col flex-center-layout">
                                                                <div className="add-new-form-group">
                                                                    <p>{this.state.templateSettings.allowMatrixUsageChangeDuringScheduling.settingDisplayColumn}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        }
                                                        {Object.values(this.state.templateSettings)
                                                            .filter(
                                                                item =>
                                                                    item.showCheckbox === "Y" &&
                                                                    (item.settingColumn === "skipDraftStage" || item.settingColumn === "clientResponseAfterCompletion")
                                                            ).map(item => (
                                                                <div key={item.settingColumn}>
                                                                    {item.settingColumn === "skipDraftStage" &&
                                                                        <p style={{fontWeight:400, paddingTop: 15, marginBottom: 15, borderTop: "1px solid #ccc"}}>
                                                                            Skip Draft
                                                                        </p>
                                                                    }
                                                                    <div className="row custom-row">
                                                                        <div className="col-md-1 custom-col" style={{maxWidth:'3.33%'}}>
                                                                            <div className="flex-center-layout">
                                                                                <FilterCheckBox
                                                                                    themeSettings={themeSettings}
                                                                                    style={{ marginLeft: 0, marginBottom: 0, marginTop: 0 }}
                                                                                    >
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        name={item["settingColumn"]}
                                                                                        id={item["settingColumn"]}
                                                                                        onChange={this.handleCheckBoxClick}
                                                                                        checked={item.settingColumnEnabled === "Y"}
                                                                                    />
                                                                                    <label htmlFor={item["settingColumn"]}></label>
                                                                                </FilterCheckBox>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-8 custom-col flex-center-layout">
                                                                            <div className="add-new-form-group">
                                                                                <p>{item["settingDisplayColumn"]}</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                        ))}

                                                        {hasFeatureAccess(Constants.FEATURE_ONGOING_ASSIGN_OVERALL_RISK) && Object.values(this.state.templateSettings)
                                                            .filter(
                                                                item =>
                                                                    item.showCheckbox === "Y" &&
                                                                    (item.settingColumn === "assignRiskAssignmentLevel")
                                                            ).map(item => (
                                                                <div key={item.settingColumn}>
                                                                    {item.settingColumn === "assignRiskAssignmentLevel" &&
                                                                        <p style={{fontWeight:400, paddingTop: 15, marginBottom: 15, borderTop: "1px solid #ccc"}}>
                                                                            Reports
                                                                        </p>
                                                                    }
                                                                    <div className="row custom-row">
                                                                        <div className="col-md-1 custom-col" style={{maxWidth:'3.33%'}}>
                                                                            <div className="flex-center-layout">
                                                                                <FilterCheckBox
                                                                                    themeSettings={themeSettings}
                                                                                    style={{ marginLeft: 0, marginBottom: 0, marginTop: 0 }}
                                                                                >
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        name={item["settingColumn"]}
                                                                                        id={item["settingColumn"]}
                                                                                        onChange={this.handleCheckBoxClick}
                                                                                        checked={item.settingColumnEnabled === "Y"}
                                                                                    />
                                                                                    <label htmlFor={item["settingColumn"]}></label>
                                                                                </FilterCheckBox>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-8 custom-col flex-center-layout">
                                                                            <div className="add-new-form-group">
                                                                                <p>{item["settingDisplayColumn"]}</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                        ))}
                                                        <p style={{fontWeight:400, paddingTop: 15, marginBottom: 15, borderTop: "1px solid #ccc"}}>
                                                            Do you want to take response for task, observation or both?
                                                        </p>
                                                        <div className="row custom-row">
                                                            <div className="col-md-8 custom-col">
                                                                <div style={{display: "flex", flexDirection: "row", gap: "20px", alignItems: "center", marginBottom:15}}>
                                                                    {Object.values(this.state.templateSettings).filter(item => item.showRadioButton === "Y" && RESPONSE_RADIO_COLUMNS.includes(item.settingColumn)).map((item, index) => (
                                                                        <TableRadioButton
                                                                            key={item.settingColumn}
                                                                            style={{marginLeft:0, display:"flex", flexDirection: "column", alignItems: "center", marginBottom: 10}}
                                                                            themeSettings={themeSettings}
                                                                        >
                                                                            <input
                                                                                type="radio"
                                                                                name="responseRadioGroup"
                                                                                id={item["settingColumn"]}
                                                                                onChange={() => this.handleRadioButtonSelection(item["settingColumn"])}
                                                                                checked={item.settingColumnEnabled === "Y"}
                                                                            />
                                                                            <label htmlFor={item["settingColumn"]} style={{marginLeft:0, fontWeight:600, color:"#000"}}>{item["settingDisplayColumn"]}</label>
                                                                        </TableRadioButton>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* Render allowEditClientComment checkbox below radio buttons */}
                                                        {hasFeatureAccess(Constants.FEATURE_CLIENT_LOGIN) &&
                                                        Object.values(this.state.templateSettings).some(
                                                            item => item.settingColumn === "allowEditClientComment" ||
                                                                item.settingColumn === "allowReassignTaskByClient" ||
                                                                item.settingColumn === "allowClientToRespond"
                                                        ) &&
                                                        <>
                                                        <p style={{fontWeight:400, paddingTop: 15, marginBottom: 15, borderTop: "1px solid #ccc"}}>
                                                            Client Login
                                                        </p>
                                                        {Object.values(this.state.templateSettings)
                                                            .filter(item => item.settingColumn === "allowEditClientComment" ||
                                                                item.settingColumn === "allowReassignTaskByClient" ||
                                                                item.settingColumn === "allowClientToRespond")
                                                            .map(item => (
                                                                <div key={item.settingColumn}>
                                                                    <div className="row custom-row">
                                                                        <div className="col-md-1 custom-col"  style={{maxWidth:'3.33%'}}>
                                                                            <div className="flex-center-layout">
                                                                                <FilterCheckBox
                                                                                    themeSettings={themeSettings}
                                                                                    style={{ marginLeft: 0, marginBottom: 0, marginTop: 0 }}
                                                                                >
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        name={item["settingColumn"]}
                                                                                        id={item["settingColumn"]}
                                                                                        onChange={this.handleCheckBoxClick}
                                                                                        checked={item.settingColumnEnabled === "Y"}
                                                                                    />
                                                                                    <label htmlFor={item["settingColumn"]}></label>
                                                                                </FilterCheckBox>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-8 custom-col flex-center-layout">
                                                                            <div className="add-new-form-group">
                                                                                <p>{item["settingDisplayColumn"]}</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))
                                                        }
                                                        </>
                                                        }
                                                        {
                                                            hasFeatureAccess(Constants.FEATURE_EMAIL_NOTIFICATION) &&
                                                            this.state.templateSettings?.defaultMailReport &&
                                                            <>
                                                            <p style={{fontWeight:400, paddingTop: 15, marginBottom: 15, borderTop: "1px solid #ccc"}}>
                                                                Default Mail Report
                                                            </p>
                                                            <div className="row custom-row">
                                                                <div className="col-md-8 custom-col">
                                                                    <MultiSelectComponent
                                                                        key={"defaultMailReport:-:"+this.state.downloadReportList.length}
                                                                        dataSource={[STANDARD_REPORT_ITEM, ...this.state.downloadReportList]}
                                                                        fields={{text:"displayReportName", value:"clientDownloadReportMapId"}}
                                                                        placeholder="Select Reports"
                                                                        mode="CheckBox"
                                                                        closePopupOnSelect={false}
                                                                        allowFiltering={true}
                                                                        select={this.handleDefaultMailReportSelect}
                                                                        removed={this.handleDefaultMailReportRemove}
                                                                        cssClass="clientsChecklist dialogcl"
                                                                        value={this.getSelectedDefaultMailReportIds().map(id => parseInt(id))}
                                                                        showDropDownIcon={true}
                                                                        showClearButton={true}
                                                                    >
                                                                        <Inject services={[CheckBoxSelection]} />
                                                                    </MultiSelectComponent>
                                                                </div>
                                                            </div>
                                                            </>
                                                        }
                                                    </>
                                                    }
                                                    {!isEmptyVariable(this.state.templateName) &&
                                                    <div className="modal-close-save m-t-15">
                                                        <div className="close-save-col">
                                                            <DialogSaveButton
                                                                themeSettings={themeSettings}
                                                                onClick={this.handleSaveFields}
                                                                type="button"
                                                                className="modal-save m-b-0"
                                                            >
                                                                {this.state.showBtnLoader ? <div class="loader-btn mt-2"></div> : 'Save'}
                                                            </DialogSaveButton>
                                                        </div>
                                                    </div>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {
                                    this.state.showMessage && 
                                    <div class="no-items-layout">
                                        <div class="no-items-card">
                                            <h6>
                                            {
                                                this.state.responseMessage
                                            }
                                            </h6>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        <AlertDialog
                            showAlertDialog={this.state.showAlertDialogInfo}
                            handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                            type={Constants.ALERT_TYPE_ALERT}
                            alertDialogMessage={this.state.alertDialogMessageInfo}
                            proceedBtnClick={this.handleAlertDialogCloseInfo}
                            proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                            themeSettings={themeSettings}
                        />

                        <Modal className="custom-dialog" show={this.state.showDialog} 
                            backdrop="static">
                            <Modal.Header>
                                <h5>{"Select Assignment Type"}</h5>
                                <button 
                                    onClick={this.handleDialogClose}
                                    type="button" data-dismiss="modal">
                                    <span class="material-icons">close</span>
                                </button>
                            </Modal.Header>
                            <hr />
                            <div class="modal-body">
                                <div className="row custom-row">
                                {
                                    !isEmptyArray(this.state.departmentsArr) &&
                                    this.state.departmentsArr.length > 1 &&
                                    <div className="col-md-6 custom-col">
                                        <div class="addnew-modal-form-group">
                                            <p>Department*</p>
                                            <RegularDropDown
                                                placeholder={this.state.selectedDepartmentName}
                                                dropdownArr={this.state.departmentsArr}
                                                labelParam="name"
                                                onDropDownItemClick={this.deptDropdownClick}
                                                defaultPlaceholderDropDown={departmentDropdownDefaultValue}
                                            />
                                            {
                                                !isEmptyVariable(this.state.formErrors['department']) &&
                                                <span class="cm-error">{this.state.formErrors['department']}</span>
                                            }
                                        </div>
                                    </div>
                                }
                                {
                                    !isEmptyArray(this.state.assignmentTypeArr) &&
                                    this.state.assignmentTypeArr.length > 1 &&
                                    <div className="col-md-6 custom-col">
                                        <div class="addnew-modal-form-group">
                                            <p>Assignment Type*</p>
                                            <RegularDropDown
                                                placeholder={this.state.selectedAssignmentType}
                                                dropdownArr={this.state.assignmentTypeArr}
                                                labelParam="name"
                                                onDropDownItemClick={this.assignmentTypeDropdownClick}
                                                defaultPlaceholderDropDown={assignmentTypeDropdownDefaultValue}
                                            />
                                            {
                                                !isEmptyVariable(this.state.formErrors['assignmentType']) &&
                                                <span class="cm-error">{this.state.formErrors['assignmentType']}</span>
                                            }
                                        </div>
                                    </div>
                                }
                                {
                                    !isEmptyArray(this.state.templateArr) &&
                                    this.state.templateArr.length > 1 &&
                                    <div className="col-md-6 custom-col">
                                        <div class="addnew-modal-form-group">
                                            <p>Template*</p>
                                            <RegularDropDown
                                                placeholder={this.state.selectedTemplate}
                                                dropdownArr={this.state.templateArr}
                                                labelParam="templateName"
                                                onDropDownItemClick={this.templateDropdownClick}
                                                defaultPlaceholderDropDown={templateDropdownDefaultValue}
                                            />
                                            {
                                                !isEmptyVariable(this.state.formErrors['template']) &&
                                                <span class="cm-error">{this.state.formErrors['template']}</span>
                                            }
                                        </div>
                                    </div>
                                }
                                </div>
                                <div class="modal-close-save">
                                    <div class="close-save-col">
                                        <button onClick={this.handleDialogClose} type="button" class="modal-close">Cancel</button>
                                        <DialogSaveButton 
                                            themeSettings={themeSettings}
                                            onClick={this.handleSave} type="button">
                                                Save
                                        </DialogSaveButton>
                                    </div>
                                </div>
                            </div>
                        </Modal>
                    </section>
                </main>
            </Router>
        );
    }
}